exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Menu_component_2HGw {\n  margin: 0 -10px;\n  padding: 0 10px;\n\n  overflow-x: auto;\n\n  max-width: 100vw;\n\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch\n}\n\n.Menu_component_2HGw::-webkit-scrollbar {\n  display: none;\n}\n\n@media (min-width: 1024px) {\n\n  .Menu_component_2HGw {\n    white-space: normal\n  }\n}\n\n.Menu_entry_1098 {\n  padding: 0 15px;\n\n  display: inline-block;\n\n  line-height: 37px\n}\n\n.Menu_entry_1098.Menu_active_1dsz {\n  border-radius: 20px;\n  background-color: #fbce5d;\n  -webkit-box-shadow: inset 0 2px 1px rgba(0, 0, 0, .15);\n          box-shadow: inset 0 2px 1px rgba(0, 0, 0, .15);\n  cursor: default;\n}\n\n.Menu_count_1lp_ {\n  color: #787878;\n}\n", ""]);

// exports
exports.locals = {
	"component": "Menu_component_2HGw",
	"entry": "Menu_entry_1098",
	"active": "Menu_active_1dsz",
	"count": "Menu_count_1lp_"
};